import type { MetaDescriptor } from "@remix-run/node";

export function titleMeta(value: string): MetaDescriptor[] {
  return [
    { title: value },
    { property: "og:title", content: value },
    { name: "twitter:title", content: value },
  ];
}
